import React from "react";
import { Skeleton, Stack, useTheme } from "@mui/material";

export default function BlogDetailsSkeleton() {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        padding: { xs: "1.5rem", sm: "2rem", md: "3rem" },
        direction: "rtl",
      }}
    >
      <Stack
        sx={{
          maxWidth: "1480px",
          width: "100%",
          mx: "auto",
          padding: { xs: "2rem 3rem", sm: "2rem 6rem", md: "4rem 10rem" },
          gap: "3rem",
          bgcolor: theme.palette.background.lowOpacityCream,
          borderRadius: "1.5rem",
          boxShadow: "0px 4px 28.4px -1px #00000069",
          position: "relative",
          minHeight: "600px",
          overflow: "hidden",
        }}
      >
        {[1, 2].map((i) => (
          <Stack key={i} spacing={2}>
            {/* Title */}
            <Skeleton
              variant="text"
              width="60%"
              height={30}
              sx={{ borderRadius: "6px" }}
            />
            {/* Image */}
            <Skeleton
              variant="rectangular"
              height={300}
              sx={{
                borderRadius: { xs: "1rem", md: "2rem" },
                width: "100%",
              }}
            />
            {/* Paragraphs */}
            <Stack spacing={1}>
              <Skeleton variant="text" width="90%" height={20} />
              <Skeleton variant="text" width="95%" height={20} />
              <Skeleton variant="text" width="85%" height={20} />
              <Skeleton variant="text" width="80%" height={20} />
            </Stack>
          </Stack>
        ))}

        {/* Background decorations (skeleton placeholders) */}
        <Skeleton
          variant="circular"
          width={100}
          height={100}
          sx={{
            position: "absolute",
            bottom: 10,
            right: 10,
            bgcolor: theme.palette.primary.lowOpacity,
          }}
        />
        <Skeleton
          variant="circular"
          width={100}
          height={100}
          sx={{
            position: "absolute",
            top: 10,
            left: 10,
            bgcolor: theme.palette.primary.lowOpacity,
          }}
        />
      </Stack>
    </Stack>
  );
}
